import React from 'react'
import classNames from 'classnames'
import format from 'date-fns/format'
import Link from 'next/link'
import { Type } from '@/components/common'
import { Pledge } from '@/services/api/pledge'
import { formatMoney } from '@/utils'
import UserCampaignCard from './UserCampaignCard'

export interface Props {
  pledge: Pledge
  className?: string
}

const UserPledgeCard: React.FC<Props> = ({ pledge, className }) => {
  return (
    <Link
      href={`/investments/expressed-interest/${pledge.id}`}
      className={classNames('active:opacity-75', className)}
    >
      <UserCampaignCard
        title={pledge.campaignName}
        subtitle={format(new Date(pledge.created), 'MMM d, yyyy')}
        rightContent={
          <Type as="h3" variant="title-xs" className="mb-[3px] font-semibold">
            {formatMoney(pledge.amount)}
          </Type>
        }
        campaignSlug={pledge.campaign}
        className="items-start rounded-lg bg-white p-3 shadow-light"
      />
    </Link>
  )
}

export default UserPledgeCard
